const getAndCacheUtmParams = () => {
    const CACHE_KEY = 'utm_cache';
    const CACHE_DURATION = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
    
    // Get current URL UTM parameters
    const urlParams = new URLSearchParams(window.location.search);
    const currentUtms = {
        utm_source: urlParams.get('utm_source'),
        utm_medium: urlParams.get('utm_medium'),
        utm_campaign: urlParams.get('utm_campaign'),
        utm_term: urlParams.get('utm_term'),
        utm_content: urlParams.get('utm_content')
    };
    
    // Remove null values
    const currentUtmsFiltered = Object.fromEntries(
        Object.entries(currentUtms).filter(([key, value]) => value !== null)
    );
    
    try {
        const cached = localStorage.getItem(CACHE_KEY);
        const now = Date.now();
        
        if (cached) {
            const { timestamp, utms } = JSON.parse(cached);
            
            // Check if cache is still valid (within 12 hours)
            const isExpired = now - timestamp > CACHE_DURATION;
            
            // Check if current UTMs are different from cached ones
            console.log("HEREHERE", currentUtmsFiltered, utms)
            const utmsChanged = JSON.stringify(currentUtmsFiltered) !== JSON.stringify(utms);
            
            if (!isExpired && !utmsChanged) {
                // Use cached UTMs
                return utms;
            }
        }
        
        // Cache new UTMs (either expired, changed, or no cache exists)
        if (Object.keys(currentUtmsFiltered).length > 0) {
            localStorage.setItem(CACHE_KEY, JSON.stringify({
                timestamp: now,
                utms: currentUtmsFiltered
            }));
            return currentUtmsFiltered;
        }
        
        // If no current UTMs, try to use cached ones if they're not expired
        if (cached) {
            const { timestamp, utms } = JSON.parse(cached);
            if (now - timestamp <= CACHE_DURATION) {
                return utms;
            }
        }
        
        // No UTMs available
        return {};
        
    } catch (error) {
        console.error('Error handling UTM cache:', error);
        return currentUtmsFiltered;
    }
};

const setVisibility = () => {
    const noAppEls = document.querySelectorAll('.no-app');
    const noWebEls = document.querySelectorAll('.no-web');
    const utmParams = document.querySelectorAll('[class*="assigned-utm_"]');
    
    if (noAppEls.length || noWebEls.length) {
        const params = new URLSearchParams(window.location.search);
        const hasKinn = params.get('app') === 'kinn';

        noAppEls.forEach(function(el) {
            if (!hasKinn) el.classList.remove('no-app');
        });
        noWebEls.forEach(function(el) {
            if (hasKinn) el.classList.remove('no-web');
        });
    }
    
    if (utmParams.length) {
        // Use cached UTM parameters
        const cachedUtms = getAndCacheUtmParams();
        const utmMedium = cachedUtms.utm_medium;
        
        console.log("cached UTMs", cachedUtms);
        console.log("utmMedium", utmMedium);
        
        utmParams.forEach(function(el) {
            const classList = el.className.split(' ');
            const utmClasses = classList.filter(cls => cls.startsWith('assigned-utm_'));

            console.log("utmClasses", cachedUtms, utmClasses);
            
            if (utmClasses.length > 0) {
                let hasCachedUtm = false;

                utmClasses.forEach(cls => {
                    console.log("cls", cls, cachedUtms[cls.replace('assigned-', '').split('=')[0]], cls.split('=')[1]);
                    if (cachedUtms[cls.replace('assigned-', '').split('=')[0]] === cls.split('=')[1]) {
                        hasCachedUtm = true;
                    }
                })
                if (hasCachedUtm) {
                    el.style.setProperty('display', 'block', 'important');
                } else {
                    el.style.display = 'none';  
                }
            }
        });
    }
}

setVisibility();

(function() {
    document.addEventListener('DOMContentLoaded', function() {
        const galleries = document.querySelectorAll('.fs-multi-carousel');
        
        galleries.forEach(function(gallery) {
            const buttons = gallery.querySelectorAll('.fs-upsell-button[data-widget-id]');
            const contentItems = gallery.querySelectorAll('.fs-multi-content-item[data-widget-id]');
            
            buttons.forEach(function(button) {
                button.addEventListener('click', function() {
                    const targetWidgetId = this.getAttribute('data-widget-id');
                    
                    contentItems.forEach(function(item) {
                        item.classList.remove('active');
                    });
                    
                    buttons.forEach(function(btn) {
                        btn.classList.remove('active');
                    });
                    
                    const targetContent = gallery.querySelector('.fs-multi-content-item[data-widget-id="' + targetWidgetId + '"]');
                    if (targetContent) {
                        targetContent.classList.add('active');
                    }
                    
                    this.classList.add('active');
                });
            });
            
            const activeButton = gallery.querySelector('.fs-upsell-button.active');
            if (!activeButton && buttons.length > 0) {
                const activeContent = gallery.querySelector('.fs-multi-content-item.active');
                if (activeContent) {
                    const activeWidgetId = activeContent.getAttribute('data-widget-id');
                    const correspondingButton = gallery.querySelector('.fs-upsell-button[data-widget-id="' + activeWidgetId + '"]');
                    if (correspondingButton) {
                        correspondingButton.classList.add('active');
                    }
                } else {
                    buttons[0].classList.add('active');
                }
            }
        });
    });
})();

(function () {
  // Only apply in secondary locales (server-driven flag on <body>)
  if (!document.body?.hasAttribute('is-secondary-language')) return;

  const SELECTOR = '.xy-widget-container fs-product-widget';
  const TIMEOUT_MS = 8000;

  function applyToAll() {
    const nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return 0;

    let updated = 0;
    nodes.forEach((el) => {
      if (!el.hasAttribute('is-secondary-language')) {
        el.setAttribute('is-secondary-language', '');
        updated++;
      }
    });

    return updated;
  }

  // Try immediately (in case widgets are already in DOM)
  applyToAll();

  const obs = new MutationObserver(() => {
    applyToAll();
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), TIMEOUT_MS);
})();

// fix for FS product widget links in SM CA FR locale
(function () {
  const htmlEl = document.documentElement;
  const locale = htmlEl.getAttribute('data-locale');
  const lang = (htmlEl.getAttribute('lang') || '').toLowerCase();

  const shouldPrefixFr = locale === 'en_ca' && lang === 'fr';
  if (!shouldPrefixFr) return;

  const prefix = '/fr';
  const TIMEOUT_MS = 8000;

  function prefixLinksInAllWidgets() {
    const widgets = document.querySelectorAll('fs-product-widget');
    widgets.forEach((w) => {
      const root = w.shadowRoot;
      if (!root) return;

      root.querySelectorAll('a.product-card[href]').forEach((a) => {
        const href = a.getAttribute('href');
        if (!href) return;

        if (/^(https?:)?\/\//i.test(href) || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;

        const path = href.startsWith('/') ? href : `/${href}`;
        if (path === prefix || path.startsWith(prefix + '/')) return;

        a.setAttribute('href', prefix + path);
      });
    });
  }

  prefixLinksInAllWidgets();

  const obs = new MutationObserver(prefixLinksInAllWidgets);
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), TIMEOUT_MS);
})();

function initSliderMcPortals() {
  function closeSliderMobileSheets() {
    document
      .querySelectorAll('.mc-sheet.mob[data-slider-portal="true"][data-open="true"]')
      .forEach((sheet) => {
        sheet.setAttribute('data-open', 'false');
        sheet.setAttribute('aria-hidden', 'true');
      });

    if (!document.querySelector('.mc-sheet.mob[data-slider-portal="true"][data-open="true"]')) {
      document.body.classList.remove('mc-sheet-open');
    }
  }

  function closeSliderDesktopPanels() {
    document
      .querySelectorAll('.mc-panel[data-slider-portal="true"][data-open="true"]')
      .forEach((panel) => {
        panel.setAttribute('data-open', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.style.display = 'none';
      });
  }

  function positionDesktopPanel(trigger, panel, align = 'left') {
    const rect = trigger.getBoundingClientRect();
    const scrollX = window.scrollX || window.pageXOffset;
    const scrollY = window.scrollY || window.pageYOffset;

    panel.style.position = 'absolute';
    panel.style.top = `${rect.bottom + scrollY + 8}px`;
    panel.style.left = '';
    panel.style.right = '';
    panel.style.transform = '';

    // Temporarily show to measure width
    panel.style.visibility = 'hidden';
    panel.style.display = 'block';

    const panelWidth = panel.offsetWidth;

    if (align === 'center') {
      panel.style.left = `${rect.left + scrollX + rect.width / 2 - panelWidth / 2}px`;
    } else if (align === 'right') {
      panel.style.left = `${rect.right + scrollX - panelWidth}px`;
    } else {
      panel.style.left = `${rect.left + scrollX}px`;
    }

    panel.style.visibility = '';
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.mc-trigger');
    if (!trigger) return;

    const slider = trigger.closest('slideshow-component-v2');
    if (!slider) return;

    const root = trigger.closest('.mc-root');
    if (!root) return;

    event.preventDefault();
    event.stopPropagation();

    if (!root.dataset.mcOwnerId) {
      root.dataset.mcOwnerId = `mc-${Math.random().toString(36).slice(2, 10)}`;
    }

    const ownerId = root.dataset.mcOwnerId;
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      let sheet = root.querySelector('.mc-sheet.mob');

      if (!sheet) {
        sheet = document.querySelector(`.mc-sheet.mob[data-owner-id="${ownerId}"][data-slider-portal="true"]`);
      }

      if (!sheet) return;

      sheet.dataset.ownerId = ownerId;
      sheet.dataset.sliderPortal = 'true';

      if (!sheet.dataset.portalMounted) {
        document.body.appendChild(sheet);
        sheet.dataset.portalMounted = 'true';
      }

      closeSliderMobileSheets();

      sheet.setAttribute('data-open', 'true');
      sheet.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mc-sheet-open');
      return;
    }

    // Desktop panel portal
    let panel = root.querySelector('.mc-panel');

    if (!panel) {
      panel = document.querySelector(`.mc-panel[data-owner-id="${ownerId}"][data-slider-portal="true"]`);
    }

    if (!panel) return;

    panel.dataset.ownerId = ownerId;
    panel.dataset.sliderPortal = 'true';

    if (!panel.dataset.portalMounted) {
      document.body.appendChild(panel);
      panel.dataset.portalMounted = 'true';
    }

    const isOpen = panel.getAttribute('data-open') === 'true';
    closeSliderDesktopPanels();

    if (isOpen) return;

    const align = root.dataset.alignment || 'left';
    positionDesktopPanel(trigger, panel, align);

    panel.setAttribute('data-open', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panel.style.display = 'block';
  });

  document.addEventListener('click', (event) => {
    const closeTrigger = event.target.closest('[data-mc-close]');
    const sheetItem = event.target.closest('.mc-sheet__item');
    const clickInsideDesktopPanel = event.target.closest('.mc-panel[data-slider-portal="true"]');
    const clickInsideTrigger = event.target.closest('slideshow-component-v2 .mc-trigger');

    if (closeTrigger || sheetItem) {
      const sheet = event.target.closest('.mc-sheet.mob');
      if (sheet && sheet.dataset.sliderPortal === 'true') {
        sheet.setAttribute('data-open', 'false');
        sheet.setAttribute('aria-hidden', 'true');

        if (!document.querySelector('.mc-sheet.mob[data-slider-portal="true"][data-open="true"]')) {
          document.body.classList.remove('mc-sheet-open');
        }
      }
      return;
    }

    if (clickInsideDesktopPanel || clickInsideTrigger) return;

    closeSliderDesktopPanels();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    closeSliderMobileSheets();
    closeSliderDesktopPanels();
  });

  window.addEventListener('resize', () => {
    closeSliderDesktopPanels();
  });

  window.addEventListener('scroll', () => {
    closeSliderDesktopPanels();
  }, true);
}

initSliderMcPortals();
